var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M1.702 2.98L1 3.312v9.376l.702.332 2.842-4.777L1.702 2.98z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M3.339 12.657l-1.637.363V2.98l1.637.353v9.324z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M2.476 2.612l.863-.406 4.096 6.216-4.096 5.372-.863-.406V2.612z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M5.38 13.248l-2.041.546V2.206l2.04.548v10.494z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M4.3 1.75l1.08-.512 6.043 7.864-6.043 5.66-1.08-.511V1.749z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M7.998 13.856l-2.618.906V1.238l2.618.908v11.71z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M6.602.66L7.998 0l6.538 8.453L7.998 16l-1.396-.66V.66z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M15 12.686L7.998 16V0L15 3.314v9.372z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iODAwIiBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxwYXRoIGZpbGw9IiM5RDUwMjUiIGQ9Ik0xLjcwMiAyLjk4IDEgMy4zMTJ2OS4zNzZsLjcwMi4zMzIgMi44NDItNC43NzdMMS43MDIgMi45OHoiLz4KICA8cGF0aCBmaWxsPSIjRjU4NTM2IiBkPSJtMy4zMzkgMTIuNjU3LTEuNjM3LjM2M1YyLjk4bDEuNjM3LjM1M3Y5LjMyNHoiLz4KICA8cGF0aCBmaWxsPSIjOUQ1MDI1IiBkPSJtMi40NzYgMi42MTIuODYzLS40MDYgNC4wOTYgNi4yMTYtNC4wOTYgNS4zNzItLjg2My0uNDA2VjIuNjEyeiIvPgogIDxwYXRoIGZpbGw9IiNGNTg1MzYiIGQ9Im01LjM4IDEzLjI0OC0yLjA0MS41NDZWMi4yMDZsMi4wNC41NDh2MTAuNDk0eiIvPgogIDxwYXRoIGZpbGw9IiM5RDUwMjUiIGQ9Im00LjMgMS43NSAxLjA4LS41MTIgNi4wNDMgNy44NjQtNi4wNDMgNS42Ni0xLjA4LS41MTFWMS43NDl6Ii8+CiAgPHBhdGggZmlsbD0iI0Y1ODUzNiIgZD0ibTcuOTk4IDEzLjg1Ni0yLjYxOC45MDZWMS4yMzhsMi42MTguOTA4djExLjcxeiIvPgogIDxwYXRoIGZpbGw9IiM5RDUwMjUiIGQ9Ik02LjYwMi42NiA3Ljk5OCAwbDYuNTM4IDguNDUzTDcuOTk4IDE2bC0xLjM5Ni0uNjZWLjY2eiIvPgogIDxwYXRoIGZpbGw9IiNGNTg1MzYiIGQ9Ik0xNSAxMi42ODYgNy45OTggMTZWMEwxNSAzLjMxNHY5LjM3MnoiLz4KPC9zdmc+Cg==";
export { SvgPosition3 as ReactComponent };